
// for debugging
// export const DICE_ANIMATION = 10;
// export const BOT_DECISION = 10;

// normal
export const DICE_ANIMATION = 1500;
export const BOT_DECISION = 2000;
